<div class="theme-selector" ClickOutside (clickOutside)="open = false">
  <div class="theme-selector__header" (click)="open = !open">
    <div class="theme-selector__current-theme" [style.background]="gradients[theme.currentTheme]">
    </div>
    <i class="icon-arrow"></i>
  </div>
  <div class="theme-selector__options" [ngClass]="{open: open}">
    @for (item of selectors; track $index) {
      <div class="theme-selector__options-block">
        <div class="theme-selector__options-block-item" (click)="setTheme(item.darkTheme)"
          [ngClass]="{'active': theme.currentTheme === item.darkTheme}">
          <div class="theme-selector__options-item" [style.background]="item.gradient"></div>
        </div>
      </div>
    }
  </div>
</div>
